import { TableHeader } from "@a7y/tailwind-catalyst";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

export function SortableHeader<T extends string>({
  field,
  label,
  sortField,
  sortOrder,
  onSort,
}: {
  field: T;
  label: string;
  sortField: T;
  sortOrder: "asc" | "desc";
  onSort: (field: T) => void;
}) {
  const isActive = sortField === field;
  return (
    <TableHeader>
      <button
        onClick={() => onSort(field)}
        className="flex items-center gap-1 hover:text-zinc-900 dark:hover:text-zinc-100"
      >
        {label}
        {isActive ? (
          sortOrder === "asc" ? (
            <ArrowUp className="h-3.5 w-3.5" />
          ) : (
            <ArrowDown className="h-3.5 w-3.5" />
          )
        ) : (
          <ArrowUpDown className="h-3.5 w-3.5 opacity-40" />
        )}
      </button>
    </TableHeader>
  );
}
